import { Types } from '../../../constants';
import { IsHelper } from '../IsHelper';
export class IsStringHelper extends IsHelper {
    constructor() {
        super(...arguments);
        this.type = Types.String;
    }
}

//# sourceMappingURL=IsStringHelper.js.map
